import { render, staticRenderFns } from "./RecommendationMenuItem.vue?vue&type=template&id=612bbd9c&scoped=true"
import script from "./RecommendationMenuItem.vue?vue&type=script&lang=js"
export * from "./RecommendationMenuItem.vue?vue&type=script&lang=js"
import style0 from "./RecommendationMenuItem.vue?vue&type=style&index=0&id=612bbd9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612bbd9c",
  null
  
)

export default component.exports